import {Component} from "../interface/component";

export class ModalComponent implements Component {
    private $trigger:JQuery;
    private $modal:JQuery;
    private $modal_content:JQuery;
    private $close_buttons:JQuery;
    private $window:JQuery<Window>;

    constructor(elem:HTMLElement) {
        this.$trigger = $(elem);
        this.$modal = $('#' + this.$trigger.data('modal-id'));
        this.$modal_content = this.$modal.find('.js-modal-content');
        this.$close_buttons = this.$modal.find('.js-close-modal');
        this.$window = $(window);
    }

    init() {
        this.$trigger.on({
            click: this.handleClick(this.openModal)
        });
        this.$close_buttons.on({
            click: this.handleClick(this.closeModal)
        });
        this.$modal_content.on({
            click: this.stopBubbling
        });
    }

    private handleClick = (func: Function) => {
        return (ev:Event) => {
            ev.preventDefault();
            ev.stopPropagation();
            return func(ev);
        };
    }

    private openModal = () => {
        this.$modal.addClass('l-modal--visible');
        this.setupWindowEvent();
    }

    private closeModal = () => {
        this.$modal.removeClass('l-modal--visible');
        this.removeWindowEvent();
    }

    private stopBubbling = (ev: Event) => {
        //stop event bubbling to handleWindowClick and closing modal
        ev.stopPropagation();
    }

    private setupWindowEvent = () => {
        this.$window.on({
            "click.fablrmodal": this.handleWindowClick
        });
    }

    private removeWindowEvent = () => {
        this.$window.off('click.fablrmodal');
    }

    private handleWindowClick = (ev: Event) => {
        ev.preventDefault();
        this.closeModal();
    }
}